import { StyleSheet, View, ViewProps } from 'react-native'
import { Color, HelpIcon, Radius, Spacing, Text } from 'zens-storybook'

const styles = StyleSheet.create({
  container: {
    borderRadius: Radius.M,
    borderWidth: 1,
    borderColor: Color.calmGrey,
    backgroundColor: Color.simplyWhite,
    padding: Spacing.M,
  },
  label: {
    color: Color.metalGrey,
    marginTop: Spacing.XS,
  },
  top: {
    flexDirection: 'row',
  },
  value: {
    flex: 1,
  },
})

interface Props extends ViewProps {
  value?: string
  label?: string
  onShowHelp?: () => void
}

const Statistic = (props: Props) => {
  const { value, label, onShowHelp, style, ...otherProps } = props

  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        {value && (
          <Text style={styles.value} level={1}>
            {value}
          </Text>
        )}
        {onShowHelp && <HelpIcon onPress={onShowHelp} />}
      </View>
      {label && <Text style={styles.label}>{label}</Text>}
    </View>
  )
}

interface SkeletonProps extends ViewProps {
  label?: true | string
}

Statistic.Skeleton = (props: SkeletonProps) => {
  const { label, style, ...otherProps } = props
  return (
    <View style={[styles.container, style]} {...otherProps}>
      <View style={styles.top}>
        <Text.Skeleton style={styles.value} level={1} />
      </View>
      {label === true ? <Text.Skeleton style={styles.label} /> : label && <Text style={styles.label}>{label}</Text>}
    </View>
  )
}

export default Statistic
